import type { FormFieldAPI } from "@/shared/forms";
import { Field } from "@/shared/forms";
import { useFieldContext } from "./FieldContext";
import type { FieldComposerConfig } from "./types";

type ConnectorField = {
    formField: FormFieldAPI<any>;
    fieldConfig: FieldComposerConfig;
    fieldPath: string;
    exactnessFieldPath?: string;
};

export function FormFieldConnector({
    children,
}: {
    children: (childProps: ConnectorField, id: string) => React.ReactNode;
}) {
    const { fieldPath, fieldConfig, exactnessFieldPath, fieldHtmlId } = useFieldContext();

    return (
        <Field name={fieldPath}>
            {(formField) => children({ formField, fieldConfig, fieldPath, exactnessFieldPath }, fieldHtmlId)}
        </Field>
    );
}
